import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { useUser } from "./useUser";

interface RoleGuardProps extends PropsWithChildren {
  roles: string[];
}

export function RoleGuard({ roles, children }: RoleGuardProps) {
  const { user } = useUser();
  const { t } = useTranslation();
  const hasRole = user?.roles?.some((r) => roles.includes(r)) ?? false;

  if (!hasRole) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "50vh",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "text.secondary",
          }}
        >
          {t("auth.noRoleAccess", "Du har inte behörighet att se denna sida.")}
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
